import { GameConstants } from "../../../GameConstants";
import { MapsLayer } from "./MapsLayer";
import { AudioManager } from "../../../AudioManager";

export class King extends Phaser.GameObjects.Container {

    private hand: Phaser.GameObjects.Image;
    private face: Phaser.GameObjects.Image;
    private eyes: Phaser.GameObjects.Sprite;
    private mouth: Phaser.GameObjects.Sprite;
    private headContainer: Phaser.GameObjects.Container;
    private mapsLayer: MapsLayer;

    constructor(scene: Phaser.Scene, mapsLayer: MapsLayer) {

        super(scene);

        this.mapsLayer = mapsLayer;

        const body = new Phaser.GameObjects.Image(this.scene, -20, 390, "texture_atlas_5", "dwarf_body");
        body.setOrigin(.5, 1);
        this.add(body);

        this.scene.tweens.add({
            targets: body,
            scaleX: .975,
            scaleY: 1.025,
            ease: Phaser.Math.Easing.Linear,
            duration: 1500,
            yoyo: true,
            repeat: -1
        });

        this.headContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
        this.add(this.headContainer);

        this.scene.tweens.add({
            targets: this.headContainer,
            y: 4,
            ease: Phaser.Math.Easing.Linear,
            duration: 1500,
            yoyo: true,
            repeat: -1
        });

        const head = new Phaser.GameObjects.Image(this.scene, 0, GameConstants.GAME_HEIGHT, "texture_atlas_5", "dwarf_head_01");
        head.setOrigin(.5, 1);
        this.headContainer.add(head);

        this.eyes = this.scene.add.sprite(0, GameConstants.GAME_HEIGHT, "texture_atlas_5", "dwarf_blink_01");
        this.eyes.setOrigin(.5, 1);
        this.headContainer.add(this.eyes);

        this.mouth = this.scene.add.sprite(0, GameConstants.GAME_HEIGHT, "texture_atlas_5", "dwarf_mouth_01");
        this.mouth.setOrigin(.5, 1);
        this.headContainer.add(this.mouth);

        this.hand = new Phaser.GameObjects.Image(this.scene, -166, 370, "texture_atlas_5", "dwarf_beer");
        this.add(this.hand); 

        const hand2 = new Phaser.GameObjects.Image(this.scene, 70, 440, "texture_atlas_5", "dwarf_arm");
        hand2.setOrigin(.5, 1);
        this.add(hand2);

        this.scene.tweens.add({
            targets: hand2,
            scaleX: .975,
            scaleY: 1.025,
            ease: Phaser.Math.Easing.Linear,
            duration: 1000,
            yoyo: true,
            repeat: -1
        });

        this.scene.anims.create({ key: "blink", frames: this.scene.anims.generateFrameNames( "texture_atlas_5", { prefix: "dwarf_blink_", start: 1, end: 6, zeroPad: 2, suffix: ""}), frameRate: 24, repeat: 0});
        this.scene.anims.create({ key: "blink2", frames: this.scene.anims.generateFrameNames( "texture_atlas_5", { prefix: "dwarf_blink_", start: 1, end: 6, zeroPad: 2, suffix: ""}), frameRate: 24, repeat: 1});

        this.scene.anims.create({ key: "mouth", frames: this.scene.anims.generateFrameNames( "texture_atlas_5", { prefix: "dwarf_mouth_", start: 1, end: 6, zeroPad: 2, suffix: ""}), frameRate: 12, repeat: 0});

        this.eyes.on("animationcomplete", () => {
            this.eyes.setFrame("dwarf_blink_01");      
        }, this);

        this.mouth.on("animationcomplete", () => {
            this.mouth.setFrame("dwarf_mouth_01");      
        }, this);

        this.scene.time.delayedCall(2500 + 7500 * Math.random(), function(): void {
            this.blink();
        }, [], this);

        this.scene.time.delayedCall(5000 + 7500 * Math.random(), function(): void {
            this.mouthAnim();
        }, [], this);
    }

    public setHead(): void {

        this.face = new Phaser.GameObjects.Image(this.scene, 0, GameConstants.GAME_HEIGHT, "texture_atlas_5", "dwarf_head_03");
        this.face.setOrigin(.5, 1);
        this.add(this.face); 
    }

    public hitTable(): void {
        
        this.scene.tweens.add({
            targets: this.hand,
            y: 340,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            onComplete: this.onTableHit,
            onCompleteScope: this
        });
    }

    private blink(): void {

        this.eyes.anims.play(Math.random() > .5 ? "blink" : "blink2");

        this.scene.time.delayedCall(2500 + 7500 * Math.random(), function(): void {
            this.blink();
        }, [], this);
    }

    private mouthAnim(): void {

        this.mouth.anims.play("mouth");

        this.scene.time.delayedCall(2500 + 10000 * Math.random(), function(): void {
            this.mouthAnim();
        }, [], this);
    }

    private onTableHit(): void {

        AudioManager.playSound("beer_thud");

        this.mapsLayer.shakeTable();

        this.hand.y = 370;

        this.scene.time.delayedCall(100, function(): void {
            this.face.setFrame("dwarf_head_02");

            this.scene.time.delayedCall(60, function(): void {
                this.face.destroy();
            }, [], this);

        }, [], this);

        // la espuma
        for (let i = 0; i < 5; i ++) {
            
            const beerBubble = new Phaser.GameObjects.Graphics(this.scene);
            beerBubble.x = -160 + 30 - 60 * Math.random();
            beerBubble.y = 320;
            beerBubble.fillStyle(0xFFE2B4);
            beerBubble.fillCircle(0, 0, 4 + 3 * Math.random());
            this.add(beerBubble);

            this.scene.tweens.add({
                targets: beerBubble,
                y: 200 + 60 * Math.random(),
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 350 + 150 * Math.random(),
                onComplete: function(): void {
                    this.scene.tweens.add({
                        targets: beerBubble,
                        y: beerBubble.y + 10,
                        alpha: 0,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 300,
                        onComplete: function(): void {
                            beerBubble.destroy();
                        },
                        onCompleteScope: this
                    });
                },
                onCompleteScope: this
            });
        }
    }
}
